import { cached } from '@glimmer/tracking';
import BaseAbility from 'uplisting-frontend/abilities/-base';
import { BookingSource } from 'uplisting-frontend/models/booking';

export default class BookingAbility extends BaseAbility<'booking'> {
  @cached
  get canEdit(): boolean {
    if (!this.isPermitted('bookings.price.edit')) {
      return false;
    }

    return this.model.isEditable;
  }

  @cached
  get canEditPrices(): boolean {
    if (!this.isPermitted('bookings.price.edit')) {
      return false;
    }

    return this.model.isUplisting || this.model.isVrbo;
  }

  @cached
  get canChangeSource(): boolean {
    const { model } = this;

    return model.isManual || model.source === BookingSource.vrbo;
  }

  @cached
  get canMove(): boolean {
    return this.isPermitted('calendar.moveEvent') && this.model.isMoveable;
  }

  @cached
  get canCancel(): boolean {
    return this.#canRemove() && !this.model.isCancelled;
  }

  @cached
  get canAirbnbCancel(): boolean {
    return (
      this.isPermitted('calendar.bookings.cancel') &&
      this.model.canBeAirbnbCancelled
    );
  }

  @cached
  get canDelete(): boolean {
    if (this.model.deletable === false) {
      return false;
    }

    return this.#canRemove();
  }

  #canRemove(): boolean {
    return this.isPermitted('calendar.bookings.cancel') && !this.model.imported;
  }
}

declare module 'uplisting-frontend/types/registries/abilities' {
  interface AbilityRegistry {
    booking: BookingAbility;
  }
}
